module.exports = __webpack_public_path__ + "img/i_review_like_on.5dae04c2.svg";